export const settings = {
    autoClose: 5000,
    closeOnClick: true,
    draggable: false,
    hideProgressBar: false,
    newestOnTop: true,
    pauseOnHover: true,
    position: "top-right"
}
